import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { urlParamsToObject } from '../utils/url';

export default function useSearchVariables() {
  const [searchParams] = useSearchParams();
  return useMemo(() => urlParamsToObject(searchParams), [searchParams]);
}
